import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function EmptyBasketList(): React.JSX.Element {
    const { t } = useTranslation("basket");
    const [buttonIsActive, setButtonIsActive] = useState<boolean>(false);

    return (
        <div className="col-sm-12">
            <div className="well well-white-border well-empty-cart">
                <p className={buttonIsActive ? "active" : ""}>
                    {t("basketEmpty")}
                    <a
                        href="/" className="btn btn-success btn-xlg"
                        onMouseEnter={(): void => setButtonIsActive(true)}
                        onMouseLeave={(): void => setButtonIsActive(false)}
                    >
                        {t("startShopping")}
                    </a>
                </p>
            </div>
        </div>
    );
}
